import { createSlice } from '@reduxjs/toolkit';
import { IAccountRedux, IUser } from './models';
import { RootState } from '../store';
import { useAppDispatch, useAppSelector } from '../hooks';

const initialState: IAccountRedux = {
  userInfo: undefined
};

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setUserInfo: (state: IAccountRedux, action) => {
      state.userInfo = action.payload;
    }
  }
});

export const { setUserInfo } = accountSlice.actions;
export const useGetUserInfo = () => {
  return useAppSelector((state: RootState) => state[accountSlice.name]);
};
export const useSetUserInfo = () => {
  const dispatch = useAppDispatch();

  return {
    setUserInfo: (userInfo: IUser) => dispatch(setUserInfo(userInfo))
  };
};
export default accountSlice;
